import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {ApiService} from '../services/api/api.service';
import {SessionService} from '../services/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
      private sessionService: SessionService
  ) {}

  canActivate(): boolean {
    if (this.sessionService) {
      this.sessionService.logout();
    }
    return true;
  }

}
